export const getCreatedQuoteStatus= state => state.quoteR.quoteStatus;
export const getCreatedQuoteData= state => state.quoteR.quoteData;
export const getQuote = state => state.quoteR;
